module.exports = "/_next/static/resources/upcycled-materials-c2eb57f0528d174f5b41b86e4ce7bec6.mp4";